"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _SvgIcon = require("../icons/SvgIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var InputWithClearButton = function InputWithClearButton(props) {
  var inputProps = _objectSpread({}, props);
  delete inputProps.width;
  delete inputProps.inputRef;
  delete inputProps.onClickClearButton;
  var style = props.style ? Object.assign({}, props.style, {
    width: "100%"
  }) : {
    width: "100%"
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-with-clear-button-container",
    style: {
      width: props.width || 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, _extends({}, inputProps, {
    className: props.className,
    ref: props.inputRef,
    style: style
  })), props.value && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    onClick: props.onClickClearButton,
    className: "clear-input-button",
    title: "Clear input"
  }, /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgClose, {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    className: "clear-btn-svg"
  })));
};
InputWithClearButton.propTypes = {
  onClickClearButton: _propTypes["default"].func.isRequired,
  width: _propTypes["default"].string,
  // component width string with unit e.g. "400px" "80%"
  inputRef: _propTypes["default"].object // react ref (created via React.createRef()) to be assigned to the <input>, typically utilised (by parent component) to set focus to the input
};
var _default = InputWithClearButton;
exports["default"] = _default;